/**
 * Event listener callback to add a special styling class to the parent of an addon
 * @param {*} event 
 */
function selectSpiceGemAddonItems(event){
    var element = event.target;
    // check if its an spicegem addon input field
    if(element.classList.contains("spice-spa-addon-checkbox-input")){
        // get the parent element and add or remove the styling class
        const parent = element.closest(".spice-spa-addon-product-item");
        if (element.checked) {
            parent.classList.add("input-checked");
        } else {
            parent.classList.remove("input-checked");

        }
    }
}

/**
 * Event listener callback to forward element click to checkbox
 * @param {*} event 
 */
function clickSpiceGemAddonItems(event){

    var element = event.target;

    const forwardList = [
        "spice-spa-addon-product-item",
        "spice-spa-addon-checkbox-input",
        "spice-spa-addon-price-main",
        "spice-spa-addon-left",
        "spice-spa-addon-right"
    ]

    if (forwardList.some(className => element.classList.contains(className))) {
        element.closest(".spice-spa-addon-product-item")
            ?.querySelector(".spice-spa-addon-checkbox-input")
            ?.click()
    }
}

/**
 * Add wrapper classes to Judge.me product reviews
 */
function applyWrapperClassesToReviews() {

    var element = document.getElementById('judgeme_product_reviews');

    if (element) {
        element.classList.add('layout-inner-wrapper', 'content-inner-wrapper');
    }
}


// Add a global eventlistener to the document to run the callback 
// also on dynamically injected dom elements
document.addEventListener("click", clickSpiceGemAddonItems);
document.addEventListener("change", selectSpiceGemAddonItems);
window.addEventListener("load", applyWrapperClassesToReviews);